/**
 * View that handles displaying and navigating the steps of the action item creation wizard
 */
define([
  "marionette",
  "modules/actions/actionGroup/actionItemModal/actionItemStep/template/actionItemStepTemplate.html",
], function (Marionette, ActionItemStepTemplate) {
  var ActionItemStepView = {};

  ActionItemStepView.actionItemStepView = Marionette.ItemView.extend({
    template: ActionItemStepTemplate,
    modelEvents: {
      change: "render",
    },
  });

  return ActionItemStepView;
});
